import * as tslib_1 from "tslib";
import { AfterViewInit, ElementRef, OnInit } from '@angular/core';
import { Airport } from '../models/airport.model';
import { QuickNavToc } from '../../shared/models/quick-nav-toc.model';
import { AirportFeeSummaryComponent } from '../airport-fee-summary/airport-fee-summary.component';
import { AirportService } from '../airport.service';
import { QuickNavComponent } from '../../shared/quick-nav/quick-nav.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog } from '@angular/material';
import { AddBusinessDialogComponent } from '../add-business-dialog/add-business-dialog.component';
import { Router } from '../../../../node_modules/@angular/router';
import { WhatsNewService } from '../../shared/services/whats-new.service';
import { WhatsnewComponent } from '../../whatsnew/whatsnew.component';
import { SubmitNewBusinessComponent } from '../submit-new-business/submit-new-business.component';
import { AnalyticsService } from '../service/google-analytics-4.service';
import { AuthService } from '../../auth/auth/auth.service';
var AirportDetailComponent = /** @class */ (function () {
    function AirportDetailComponent(_whatsNewService, _businessManagerService, _toggleService, _matDialog, _router, _airportService, _analyticsService, _auth) {
        this._whatsNewService = _whatsNewService;
        this._businessManagerService = _businessManagerService;
        this._toggleService = _toggleService;
        this._matDialog = _matDialog;
        this._router = _router;
        this._airportService = _airportService;
        this._analyticsService = _analyticsService;
        this._auth = _auth;
        this.toc = new QuickNavToc('airport-quicknav', [{
                label: 'Overview',
                fragment: 'overview',
                visible: true
            }, {
                label: 'FBOs',
                fragment: 'fbos',
                visible: true
            }, {
                label: 'Food/Lodging/Activities',
                fragment: 'local',
                visible: true
            }, {
                label: 'Flying Clubs',
                fragment: 'flyingclubs',
                visible: true
            },
            {
                label: 'Runways',
                fragment: 'runways',
                visible: true
            }, {
                label: 'TFRs and NOTAMs',
                fragment: 'notams',
                visible: true
            }, {
                label: 'Procedures',
                fragment: 'procedures',
                visible: true
            },
            {
                label: 'Comms',
                fragment: 'comms',
                visible: true
            }, {
                label: 'Weather',
                fragment: 'wx',
                visible: true
            }]);
        this.isFlightDeckAdmin = false;
        this.editModeSet = false;
        this.isAirportManager = false;
    }
    Object.defineProperty(AirportDetailComponent.prototype, "businessesWithFees", {
        /**
         * Returns a subset of the list of businesses at this airport that either (1) have overview fees reported, or (2)
         * provide fuel. This is used for displaying the fee summary section, which is meant to list all FBOs which may
         * have fees. In the case where fees are not reported, a placeholder message is shown saying the location has not
         * disclosed fees.
         */
        get: function () {
            return this.airport.businesses.filter(function (b) { return AirportService.shouldShowFees(b); });
        },
        enumerable: true,
        configurable: true
    });
    AirportDetailComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, showWhatsNew, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.userManagesAirport(this.airport.airportId)];
                    case 1:
                        _a.isAirportManager = _c.sent();
                        _b = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 2:
                        _b.isFlightDeckAdmin = _c.sent();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        this.oldAirport = this.airport;
                        return [4 /*yield*/, this._whatsNewService.shouldShowWhatsNew()];
                    case 3:
                        showWhatsNew = _c.sent();
                        if (showWhatsNew) {
                            dialogRef = this._matDialog.open(WhatsnewComponent);
                            dialogRef.afterClosed().subscribe(function (result) {
                                _this._whatsNewService.displayedWhatsNew();
                            });
                        }
                        this._analyticsService.pageView('airport_page', 'Airport Detail');
                        this._analyticsService.trackEvent('airport_viewed', this.airport.identifier, this.airport.identifier);
                        if (this._auth.authenticated && this._auth.endUser) {
                            this._analyticsService.trackEvent('airport_loggedin', this._auth.recid, this._auth.recid);
                        }
                        else {
                            this._analyticsService.trackEvent('airport_loggedout', '', '');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /* async ngDoCheck() {
       /
        * This hack is to handle routes coming from the autocomplete search.
        * Without it, an airport manager would look like they could manage airports they don't have permission to manage.
        * The API prevents any actual changes regardless of what the interface shows without this hack.
        /
      if (this.airport && this.oldAirport && this.airport.airportId !== this.oldAirport.airportId) {
        this.oldAirport = this.airport;
        this.isAirportManager = await this._businessManagerService.userManagesAirport(this.airport.airportId);
        if (!this.isAirportManager) {
          this._toggleService.setState(false);
        }
      }
    } */
    AirportDetailComponent.prototype.ngAfterViewInit = function () {
        /*
        const $detailBody = $(this.body.nativeElement);
        const $page = $detailBody.closest('.detail-page');
        this.quicknav.setContainerHeight($page.height() + 1000);
        */
    };
    Object.defineProperty(AirportDetailComponent.prototype, "sortedFBOs", {
        get: function () {
            if (!this.isFlightDeckAdmin) {
                return this.airport.businesses
                    .filter(function (b) { return b.isFbo; })
                    .filter(function (fbo) { return !fbo.hideBusiness; })
                    .filter(function (fbo) { return !fbo.notApproved; })
                    .sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            }
            return this.airport.businesses
                .filter(function (b) { return b.isFbo; })
                .sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    AirportDetailComponent.prototype.onReloadAirport = function (reload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AirportDetailComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AirportDetailComponent.prototype.openAddDialog = function (facilityType) {
        var _this = this;
        var dialogRef = this._matDialog.open(AddBusinessDialogComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airport: this.airport,
                facilityType: facilityType
            }
        });
        dialogRef.afterClosed().subscribe(function (closeDialog) {
            if (closeDialog.cancelButtonClicked) {
                return;
            }
            if (closeDialog.success) {
                var type = void 0;
                if (facilityType === 'FLYING CLUB') {
                    type = 'flyingclub';
                }
                else if (facilityType === 'BUSINESS') {
                    type = 'business';
                }
                _this.reloadAirport(_this.airport.identifier);
                _this._router.navigateByUrl("/" + type + "/" + closeDialog.payload);
            }
        });
    };
    AirportDetailComponent.prototype.openSubmitNewBusinessDialog = function (facilityType) {
        var dialogRef = this._matDialog.open(SubmitNewBusinessComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                airport: this.airport,
                facilityType: facilityType
            }
        });
    };
    return AirportDetailComponent;
}());
export { AirportDetailComponent };
